"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * class used to store the helper functions
 */
var ApiHelpers = /** @class */ (function () {
    function ApiHelpers() {
        /**
       * Checks [adobeid.api_parameters]{@link adobeid} for custom parameters for an API.
       * @param apiName - represents the used api name
       * @param apiParameters - represents the parameters set from outside for api endpoints read from adobeId
       * @returns {!Object}
       */
        this.getCustomApiParameters = function (apiParameters, apiName) {
            return Object.keys(apiParameters).reduce(function (acumulator, key) {
                if (key.indexOf(apiName) > -1) {
                    acumulator[key] = apiParameters[key] || null;
                }
                return acumulator;
            }, {});
        };
    }
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @param apiParameters the api parameters from AdobeId data
     * @param apiName api name
     * @returns IDictionary representing the merged properties
     */
    ApiHelpers.prototype.mergeExternalParameters = function (externalParameters, apiParameters, apiName) {
        return __assign(__assign({}, this.getCustomApiParameters(apiParameters, apiName)), externalParameters);
    };
    return ApiHelpers;
}());
exports.default = new ApiHelpers();
